import { memo, useEffect } from 'react'
import { useAccount } from '@starknet-react/core'
import { ChainType } from '../../constants/chains'
import { updateCurrentNetwork } from '../../store/app/actions'
import { useChainType } from '../../store/connect/hooks'
import { useAppDispatch } from '../../store'
import { BigNumber } from '@ethersproject/bignumber'

export const Web3StarknetProviderUpdater = memo(() => {
  const dispatch = useAppDispatch()
  const { chainId, account, isConnected, isConnecting } = useAccount()
  const chainType = useChainType()

  useEffect(() => {
    if (chainType !== ChainType.Starknet) {
      return
    }
    if (isConnected && chainId) {
      console.log(chainId, BigNumber.from(chainId).toHexString())
      dispatch(updateCurrentNetwork(BigNumber.from(chainId).toHexString()))
    }
  }, [isConnected, chainId, chainType])
  return null
})
